const Demo6Content7 = () => {
    return (
        <section id="content-7" className="content-7 wide-60 content-section division">
            <div className="container">
                <div className="row d-flex align-items-center">
                    <div className="col-md-6 order-last order-md-2">
                        <div className="txt-block left-column wow fadeInLeft">
                            <span className="section-id txt-upcase">Easy Integration</span>
                            <h2 className="h2-xs">Intuitive features, powerful results</h2>
                            <ul className="simple-list">
                                <li className="list-item">
                                    <p className="p-lg">
                                        Fringilla risus, luctus mauris auctor euismod an iaculis luctus magna purus pretium ligula purus and quaerat
                                    </p>
                                </li>
                                <li className="list-item">
                                    <p className="p-lg">
                                        Nemo ipsam egestas volute turpis dolores undo ultrice aliquam quaerat at sodales sapien purus
                                    </p>
                                </li>
                            </ul>
                            <div className="tools-list ico-40 mt-30">
                                <h6 className="h6-lg">Technologies We Use:</h6>
                                {['HTML5', 'CSS3', 'WordPress', 'JavaScript', 'UI Design'].map((tech) => (
                                    <span key={tech} className="tech-badge text-black-50">
                                        {tech}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 order-first order-md-2">
                        <div className="content-7-img wow fadeInRight">
                            <img className="img-fluid" src="/images/demo6/dashboard-05.png" alt="content" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Demo6Content7;
